import React from "react";
import { Helmet } from "react-helmet";

// Assets
import blogHeaderImage from "../../../assets/images/blog/test-blog.jpeg";
import blogAsset from "../../../assets/images/blog/blog-apiLive-asset.jpg";


import "../blogTemplate.css";
import Footer from "../../Footer";

// Construct your blog data with an imported shareImage
const blogData = {
  title: "API Documentation Now Live",
  description: "Discover our newly launched API Documentation that simplifies integrating powerful video analysis features into your applications. Dive into comprehensive guides, code examples, and interactive resources designed to empower our developer community.",
  shareImage: blogHeaderImage,
};

function BlogHeader() {
  return (
    <div className="blog-header">
      <div className="blog-topic-pill">Product</div>
      <h1>{blogData.title}</h1>
      <p className="blog-info">April 21, 2025 • 4 min read</p>
    </div>
  );
}

function BlogBody() {
    return (
      <div className="blog-body">
        {/* Full-width share image */}
        <div className="blog-image-wrapper">
          <img 
            src={blogData.shareImage} 
            alt="API Documentation Now Live" 
            className="blog-picture" 
          />
        </div>
  
        {/* Introductory Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-text">
              <p>
                We are thrilled to announce that our <strong>API Documentation</strong> is now live! With our revamped documentation, developers can easily integrate and leverage the full power of Bumpups' video analysis services.
              </p>
            </div>
          </div>
        </div>
  
        {/* Getting Started Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Getting Started</strong>
            </div>
            <div className="blog-text">
              <p>
                Our documentation provides a comprehensive guide to all the RESTful endpoints and integration methods available. Whether you’re looking to generate summaries, extract timestamps, or engage in interactive querying, our docs have you covered.
              </p>
              <p>
                Check out our <a href="https://docs.bumpups.com/docs/getting-started" target="_blank" rel="noopener noreferrer"><em>API documentation</em></a> for detailed instructions.
              </p>
            </div>
          </div>
        </div>
  
        {/* Key Features Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Key Features at a Glance</strong>
            </div>
            <div className="blog-text">
              <p>
                The new documentation outlines key features such as:
              </p>
              <ul>
                <li><strong>RESTful Endpoints:</strong> Leverage standard HTTP requests to access powerful video analysis functionalities.</li>
                <li><strong>Actionable Insights:</strong> Convert raw video data into concise summaries, key timestamps, and more.</li>
                <li><strong>Interactive Querying:</strong> Ask targeted questions about your videos and receive context-aware answers.</li>
                <li><strong>Extensibility:</strong> Our platform is designed to grow, with plans to support additional video sources like Zoom and Facebook.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="blog-image-wrapper">
        <img src={blogAsset} alt="Placeholder content" className="blog-picture" />
      </div>
  
        {/* Developer Ecosystem Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Empowering the Developer Ecosystem</strong>
            </div>
            <div className="blog-text">
              <p>
                With the launch of our new documentation, Bumpups is committed to supporting our vibrant developer community. Our detailed guides, code examples, and interactive resources ensure that you can integrate our API seamlessly into your projects.
              </p>
            </div>
          </div>
        </div>
  
        {/* Call to Action Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Explore the Documentation Today</strong>
            </div>
            <div className="blog-text">
              <p>
                Ready to transform your video content into actionable insights? Dive into our comprehensive <a href="https://docs.bumpups.com/docs/getting-started" target="_blank" rel="noopener noreferrer">API documentation</a> to get started.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  

function BlogFooter() {
  return (
    <div>
      <footer className="blog-footer">
        <hr className="blog-footer-line" />
      </footer>
    </div>
  );
}

function blogApiDocsLaunch() {
  return (
    <div className="blog-template">
      <Helmet>
        <title>{blogData.title} | Bumpups.com</title>
        <meta name="description" content={blogData.description} />

        {/* Open Graph meta tags for sharing */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.description} />
        <meta property="og:image" content={blogData.shareImage} />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.description} />
        <meta name="twitter:image" content={blogData.shareImage} />
      </Helmet>
      <BlogHeader />
      <BlogBody />
      <BlogFooter />
      <Footer />
    </div>
  );
}

export default blogApiDocsLaunch;
